class BaseAction {
    actionType;
    actionName;
    className;
    startTime;
    duration;
    icon;

    constructor (props = {}) {
        this.actionType = props.actionType || ""; // type of the action
        this.actionName = props.actionName || ""; // action's name
        this.className = props.className || ""; //class name for pruning usage
        this.startTime = props.startTime || 0; // start time of the action
        this.duration = props.duration || 0; // duration of the action in a timeline

        this.actionId = props.actionId;
    }

    get() {
        throw new Error("subclass responsibility");
    }

    shouldExecute(actionId) {
        return actionId === this.actionId;
    }

    cancel() {

    }

    init() {

    }
}

export default BaseAction;